module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow2_wh-c984f4127746a7a02152371b81cbd2e0.png";